import { object, string } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"

import { userSettingSitesFormData } from "../@signals"


const schema = object({
	color: string().required('Color is required'),
	id_site: string().required('Site is required'),
})

export default function useUserSettingsSiteValidator() {
	const { isValid, errors } = useValidatorSeeker(userSettingSitesFormData.value, schema)

	return {
		isValid,
		colorError: errors.name || null,
		siteError: errors.id_site || null
	}
}